export default {
  introSteps: {
    exportFile: 'Export the survey without data from the other Arena server (e.g. Dev or QA)',
    selectFile: 'Select the exported file (.zip): it is compared with this survey and the differences are shown',
    applyChanges:
      'Review the differences and apply the selected changes to this survey (deletions are never selected by default)',
    publish: 'Changes are saved as draft: test the form and publish the survey to make them effective',
  },
  fileTooLarge:
    'The selected file is too big (max {{maxSize}} MB): export the survey without data, records and their files are not needed to compare surveys',
  selectNewSource: 'Select a new source',
  selectNewSourceInfo: 'Discard this comparison and select another survey file or survey',
  refreshComparison: 'Refresh comparison',
  refreshComparisonInfo: 'Compare the same file again with the current version of this survey (e.g. after editing it)',
  sourceSurvey: 'Compared survey: {{name}}',
  compareWithSurvey: 'Or compare with another survey on this server:',
  fingerprint: {
    thisSurvey: 'This survey',
    comparedSurvey: 'Compared survey',
    equal: 'Same as this survey',
    different: 'Different from this survey',
    label: 'Fingerprint',
    structural: 'structural',
    info: 'Fingerprints of the survey definition (draft). Equal fingerprints mean equal definitions. The first one includes the internal ids: it is equal only for copies of the same survey (e.g. exported and imported on another server). The structural one uses names and codes: it is equal also for surveys created separately with the same structure. Names, labels, ids, dates and publishing status are not part of it.',
    copy: 'Copy the full fingerprint: {{value}}',
    copied: 'Fingerprint copied to clipboard',
  },
  identical: 'The surveys are identical',
  counts: '{{added}} only in the compared survey, {{changed}} changed, {{removed}} only in this survey',
  surveyInfoChanged: 'Survey info (languages, cycles, labels) differs: see the "Survey info" tab',
  onlyDifferences: 'Show only differences',
  hideLayoutOnly: 'Hide layout-only differences',
  apply: 'Apply selected changes ({{count}})',
  applyConfirm: `Apply {{count}} selected changes to this survey?
Changes are saved as draft: they will reach the records only when the survey is published.`,
  willBeDeleted: 'will be deleted',
  removedNodeDefInfo:
    'This node definition is only in this survey: applying this change deletes it (together with its descendants) from this survey.',
  removedItemInfo: 'Only in this survey: applying this change deletes it from this survey.',
  applyConfirmWithDeletionsHeader: 'Confirm the deletions',
  applyConfirmWithDeletions:
    'Apply {{count}} selected changes to this survey?\n\n**{{deletionsCount}} of them delete elements of this survey** (elements not in the compared survey):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Apply and delete',
  confirmSurveyName: 'Enter the name of this survey to confirm:',
  deletionOfItemsOf: 'elements only in this survey of **{{name}}**',
  moreDeletions: '... and {{count}} more',
  applyCompleted: 'Changes applied: {{applied}}, skipped: {{skipped}}. Publish the survey to make them effective.',
  tabs: {
    nodeDefs: 'Node definitions',
    categories: 'Categories',
    taxonomies: 'Taxonomies',
    surveyInfo: 'Survey info',
    surveyFiles: 'Files',
  },
  status: {
    added: 'Only in compared survey',
    changed: 'Changed',
    removed: 'Only in this survey',
  },
  statusLabel: 'Status',
  matchedBy: {
    uuid: 'Matched by internal id',
    name: 'Matched by name (internal ids are different)',
    manual: 'Matched manually: applied as a rename',
  },
  renameCandidate: 'It could be "{{name}}" of this survey, renamed',
  possibleRename: 'possible rename',
  matchAsRename: 'Match as renamed',
  unmatch: 'Undo match',
  props: {
    branding: 'Branding',
    columnsNo: 'Columns',
    columnsOrder: 'Columns order',
    cycles: 'Cycles',
    defaultCycleKey: 'Default cycle',
    descriptions: 'Descriptions',
    extra: 'Extra properties',
    family: 'Family',
    fieldManualLinks: 'Field manual links',
    formLayout: 'Form layout',
    genus: 'Genus',
    gridPosition: 'row {{row}}, column {{column}}, width {{width}}, height {{height}}',
    itemExtraDef: 'Extra properties',
    keepNonApplicableValues: 'Keep not applicable values',
    labels: 'Labels',
    languages: 'Languages',
    layout: 'Layout',
    levels: 'Levels',
    messages: 'Messages',
    pagesOrder: 'Pages order',
    parent: 'Parent entity',
    preloadedMapLayersEnabled: 'Preloaded map layers enabled',
    reportingData: 'Reporting data',
    sampleBasedImageInterpretationEnabled: 'Sample based image interpretation',
    samplingPolygon: 'Sampling polygon',
    scientificName: 'Scientific name',
    size: 'Size',
    srs: 'Spatial reference systems',
    surveyDocOptions: 'Survey documentation options',
    userExtraPropDefs: 'User extra properties',
    validations: 'Validations',
    vernacularLanguageCodes: 'Vernacular name languages',
    vernacularNames: 'Vernacular names',
  },
  fileTypes: {
    preloadedMapLayer: 'Preloaded map layer',
    surveyDocImage: 'Survey documentation image',
    brandingSurveyLogo1: 'Survey logo 1',
    brandingSurveyLogo2: 'Survey logo 2',
    brandingSurveyLogo3: 'Survey logo 3',
    brandingLandingBackground: 'Landing page background',
  },
  cycle: 'cycle {{cycle}}',
  property: 'Property',
  sourceValue: 'Compared survey',
  targetValue: 'This survey',
  emptyValue: '(empty)',
  layoutOnly: 'layout only',
  selectItem: 'Select an item to see the details',
  noDifferences: 'No differences',
  identicalItem: 'No differences',
  dependsOn: 'Applied together with:',
  itemsCount: 'items: {{added}} added, {{changed}} changed, {{removed}} only in this survey',
  itemCode: 'Code',
  taxaCount: 'taxa: {{added}} added, {{changed}} changed, {{removed}} only in this survey',
  taxonCode: 'Code',
  changes: 'Changes',
  moreItems: '... and {{count}} more items',
  categoryRemoval: 'Delete the items (and levels) only in this survey',
  taxonomyRemoval: 'Delete the taxa and vernacular names only in this survey',
  removalSelected: 'deletion selected',
  publishedKept: '(published: kept)',
  reasons: {
    categoryInUse: 'The category is used by node definitions that are not deleted',
    categoryMissing: 'The category is missing in this survey',
    cycleMissing: 'A cycle is missing in this survey',
    dependencyNotApplicable: 'A change it depends on cannot be applied',
    parentMissing: 'The parent node definition is missing in this survey',
    publishedCategoryChanged: 'The category of a published node definition cannot be changed',
    publishedKeyChanged: 'The "key" property of a published node definition cannot be changed',
    publishedMoveNotSupported: 'A published node definition cannot be moved to another entity',
    publishedMultipleChanged: 'The "multiple" property of a published node definition cannot be changed',
    publishedTaxonomyChanged: 'The taxonomy of a published node definition cannot be changed',
    publishedTypeChanged: 'The type of a published node definition cannot be changed',
    taxonomyInUse: 'The taxonomy is used by node definitions that are not deleted',
    taxonomyMissing: 'The taxonomy is missing in this survey',
    nodeDefUsedByOthers: 'Other node definitions use it in their expressions: update them too',
    publishedCategoryItemsKept: 'Published items cannot be deleted: they are kept',
    publishedCategoryLevelsKept: 'Published levels cannot be deleted: they are kept',
    publishedCyclesRemoved: 'Removing cycles from a published node definition deletes its data in those cycles',
    publishedLanguagesRemoved: 'Removing languages deletes their labels when the survey is published',
    publishedNameChanged: 'Renaming a published node definition: expressions using the old name must be updated',
    publishedNodeDefDeleted: 'The node definition is published: its data will be deleted when the survey is published',
    publishedSurveyCyclesRemoved: 'Removing cycles deletes their records when the survey is published',
    publishedTaxaKept: 'Published taxa cannot be deleted: they are kept',
    publishedVernacularNamesKept: 'Published vernacular names cannot be deleted: they are kept',
  },
}
